
























































































































































import axios from "axios"
import {Component, Prop, Vue} from 'vue-property-decorator';
import {counter} from "@fortawesome/fontawesome-svg-core";


@Component({
    components: {}
})
export default class LocationBox extends Vue {
    countries: any = [{country:"Gurgaon",text:"Popularly known as Millennium City, Gurgaon is a city just southwest of New Delhi in northern India. It has emerged as one of the most important offshoring centers in the world. Gurgaon’s skyline with its many skyscrapers is nationally recognized and it has the presence of about 250 of the Fortune 500 companies. The city also has an exciting food scene and is home to the famous Cyber Hub, a melting pot of more than 50 of the top culinary brands and interesting retro bars, pubs and entertainment zones for kids."},
        {country:"San Antonio, Texas", text:"Rackspace's 1.2 million square foot global headquarters is nestled at the edge of the scenic Texas Hill Country in San Antonio, the 7th largest city in the U.S. True to our Fanatical Support roots, Rackspace chose to become a corporate citizen in a community that needed help and set out to renovate an abandoned mall. Now the center of a growing technology ecosystem giving rise to start-ups and educational programs that will fuel the future of the industry, Rackspace’s corporate office, called “The Castle” provides an engaging, creative work environment that encourages Rackers to deliver their best every day."},
        {country:"Austin, Texas", text:"The capital of Texas, Austin is also known as the \"live music capital of the world.” With the University of Texas campus downtown, the city offers a vibrant nightlife along with parks, lakes, and historic landmarks. Austin's food scene includes restaurants boasting some of the best chefs in the nation, including award-winning Franklin BBQ, and culinary masters that will make any foodie's mouth water. One of the fastest growing cities in the United States, Austin offers a rich quality of life, access to outdoor recreation, top-notch education, eclectic entertainment, and job growth. Metro-rail access that runs through the city makes getting around easy. Rackspace's offices are centrally located near the city's epi-center with easy access to the college campus, Barton Springs, shopping, and a variety of attractions."},
        {country:"Mexico City", text:"The capital of Mexico, Mexico City is one of the world's largest metropolitan areas and a global financial center. With deep history, Mexico City is known for its architecture, cathedrals, and art. Home to the Templo Mayor, a 13th-century Aztec temple, as well as the birthplace of artists such as Diego Rivera and Frida Kahlo, Mexico City is becoming a hotspot for contemporary art."},
        {country:"Jersey City, New Jersey", text:"One of the most diverse cities in the nation, Jersey City is home to panoramic views of Manhattan, Ellis Island, and the Statue of Liberty. Known for its vibrant restaurant and art scene, and picturesque historic districts and landmark attractions, Jersey City has the benefits of a big metropolitan with the feeling of a small community."},
        {country:"Chicago, Illinois", text:"Bears, Cubs, Bulls, White Sox, and Rackers—all professional teams on a mission to win and all call Chicago home. And for good reason. Chicago, the third largest city in the U.S., rests next to Lake Michigan and offers everything from deep dish pizza and an amazing skyline, the Miracle Mile, and a 110-ton metallic \"Bean\" among an amazing skyline and museum mecca. The city also features the home of the \"Robots,\" Rackspace's Chicago team mascot. Along with robots, team members show their pride in the many professional sports team that call Chicago home—displaying banners and flags and wearing jerseys and t-shirts to represent their favorites."},
        {country:"Ashburn, Virginia", text:"At the heart of Virginia's Data Center Alley, Ashburn is located in the Dulles Technology Corridor and is also part of the Washington DC metropolitan area. Ashburn offers a combination of rich American heritage, culinary highlights, award-winning wineries, and pastoral landscapes. Ashburn offers educational and technological development opportunities, with George Washington University's Virginia Science and Technology campus as well as easy access to Washington DC and technology powerhouses."},
        {country:"Dallas, Texas", text:"The western hats, horses, and skyscrapers that inform the popular iconic Texas imagery are all found in Dallas/Fort Worth (DFW). DFW is a metropolitan area that includes 13 counties in North Texas. As one of the largest metropolitan centers in the United States, DFW is an economic and cultural hub with major manufacturing and technology companies on one side and farming and ranching on the other. The area boasts private and public universities and professional sports teams. Major airports and continually expanding public transportation systems support travel to and from the area."},
        {country:"Greater London", text:"Our Hayes based office is a beautifully architectured modern glass building (think bright and spacious) and our facilities consist of a canteen, games room, gym, training campus, free parking and our very own Mini Cooper housed in our lobby! Hayes Town has a historical culture, housing companies such as The Old Vinyl Factory where ground breaking records by The Beatles, Pink Floyd and the Rolling Stones were pressed. The Rackspace office is a 5 minute walk from Hayes and Harlington station, a 20 minute drive from Heathrow Airport, a 25 minute train journey to Central London and has great connections from both the M4 and M25 motorway. A robust transit system connects the regions making getting to and from the offices extremely accessible for all."},
        {country:"Munich", text:"A city rich in history and famous for its annual Oktoberfest, Munich pairs stunning Gothic architecture with thriving & modern industries of finance and technology. The office is located in the heart of Munich on Stachus and is easily accessible via public transportation including train, bus, tram and subway. Be sure to stop at the nearby Viktualienmarkt, where you will find delicious regional specialties including the famous Munich white sausage. With fine restaurants, museums and art galleries just a few doors down, our office takes ‘working where you play’ to the next level."},
        {country:"Zurich", text:"Taking top honors in the Great Place to Work Awards for two years running, Rackspace's Zurich office offers a variety of opportunities for growth, teambuilding, and innovation. Representing 4 nations and 15 different languages, the Zurich team offers cultural diversity that drives openness and new ideas. Zurich is the largest city and economic center of Switzerland and offers fantastic public transportation along with natural and historic landmarks."},
        {country:"Amsterdam", text:"Rackspace's Amsterdam office is conveniently located 10 minutes from the Amerstand Schiphol Airport and 5 minutes from the city's centre. Based at Amsterdam Sloterdijk, the office offers easy transportation and parking."},
        {country:"Melbourne", text:"An amazing, multicultural city, Melbourne is known for high fashion, rich culture, and fine restaurants. As Australia’s second largest city, it has attracted new residents from across the globe contributing to its rich diversity. The locals enjoy the picturesque views, European-style architecture, and the amazing diversity of food brought to life by the many different cultures. Sports are taken seriously – with many getting the day off for the AFL Grand Final!"},
        {country:"Hyderabad", text:"Hyderabad is the capital of southern India's Telangana state. It has a rich and regal history; the Old City of Hyderabad is one of India's most ancient quarters and home to iconic landmarks such as Charminar. Present day Hyderabad is also a major center for the technology industry and its modern neighborhoods are home to malls, multiplexes, pubs and sleek restaurants."},
        // {country:"Remote - IN", text:"Flexibility in work arrangements allow Rackers to meet the demands of their careers & personal lives. That’s why we enable remote working for many roles through tools & technologies like Zoom & Slack that enable Rackers to succeed & stay connected. Since engagement is a core tenant of our culture, we also invest in remote Racker management training for our leaders with remote Rackers."},
        // {country:"Remote - NL", text:"Flexibility in work arrangements allow Rackers to meet the demands of their careers & personal lives. That’s why we enable remote working for many roles through tools & technologies like Zoom & Slack that enable Rackers to succeed & stay connected. Since engagement is a core tenant of our culture, we also invest in remote Racker management training for our leaders with remote Rackers."},
        // {country:"Remote - US", text:"Flexibility in work arrangements allow Rackers to meet the demands of their careers & personal lives. That’s why we enable remote working for many roles through tools & technologies like Zoom & Slack that enable Rackers to succeed & stay connected. Since engagement is a core tenant of our culture, we also invest in remote Racker management training for our leaders with remote Rackers."},
        // {country:"Remote - UK", text:"Flexibility in work arrangements allow Rackers to meet the demands of their careers & personal lives. That’s why we enable remote working for many roles through tools & technologies like Zoom & Slack that enable Rackers to succeed & stay connected. Since engagement is a core tenant of our culture, we also invest in remote Racker management training for our leaders with remote Rackers."},
    ];





    DepartmentValues: any = [];
    uniqueArrDep: any = [];
    uniqueDepartments: any = [];
    list: any = [];
    location: any = null;

    jobCount: any = 0;


    async mounted() {

        // this.DepartmentValues.map = this.DepartmentValues.map ? this.DepartmentValues.map.replace("%2C+", ", ") : "null"

        await this.listDepartmentValues()
        this.DepartmentValues.filter(async (x:any) => await !x.categories.location.includes('Remote'))
        this.uniqueArrDep = [...new Set(this.DepartmentValues.map((data: any) => data.categories.location))]

        await this.uniqueArrDep.map((x: any) => {
            this.jobCount = 0
            this.DepartmentValues.map((y: any) => {
                if (y.categories.location === x) {
                    this.jobCount++
                }
            })

            this.uniqueDepartments.push({location: x, jobCount: this.jobCount})
        })
        this.uniqueDepartments = await this.removedRemoteLocation(this.uniqueDepartments)

    }

    async listRemoteValues() {
        await axios.get(`https://api.lever.co/v0/postings/rackspace?location=Remote%20-%20US&location=Remote%20-%20IN&location=Remote%20-%20UK&location=Remote%20-%20MX&location=Remote%20-%20CA`)
            .then(((jobRes) => {
                this.listRemoteValues = jobRes.data;
            }))

    }

    async listDepartmentValues() {
        await axios.get(`https://api.lever.co/v0/postings/rackspace`)
            .then(((jobRes) => {
                this.DepartmentValues = jobRes.data;
            }))

    }
    async removedRemoteLocation(locations:[]) {
        return locations.filter((x:any) => !x.location.includes('Remote') )

    }

}

